export class BuildabilityComponent {
    public minDistanceGrids: number[][][];
    public lastHeldBy: number[];
}



// WEBPACK FOOTER //
// ./src/common/components/BuildabilityComponent.ts